// store.js
import { configureStore } from "@reduxjs/toolkit";
import ApiSlice from "./ApiSlice";
import AppointmentSlice from "./AppointmentSlice";
import BookingSlice from "./BookingSlice";
import LabAppointmentApiSlice from './LabAppointmentApiSlice'
import LabAppointmentSlice from './LabAppointmentSlice'
import changeStateReducer from "./changeStateSlice";

const store = configureStore({
  reducer: {
    appointment: AppointmentSlice,
    labAppointment: LabAppointmentSlice,
    labAppointmentApi: LabAppointmentApiSlice,
    api: ApiSlice,
    bookings: BookingSlice,
    changeState: changeStateReducer, 
  },
});

export default store;
